import { PUSH_ALERT, REMOVE_ALERT } from "redux/actions/types";

const initialState = {
    alerts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PUSH_ALERT:
            return {
                alerts: state.alerts.every((val) => val.message !== action.payload.message)
                    ? [...state.alerts, action.payload]
                    : state.alerts,
            };

        case REMOVE_ALERT:
            return {
                alerts: state.alerts.splice(1, state.alerts.length),
            };

        default:
            return state;
    }
};
